<template>
	<div class="tpl integral-detail-wrap">
		<mt-header title="积分明细" fixed>
			<router-link :to="{name:'my-integral'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="detail-list">
			<ul>
				<li v-for="item in integralInfo">
					<div class="item-name">
						<p class="item-title">{{item.name}}</p>
						<p class="item-time">{{item.create_time | toDateTime | convertTime("YYYY-MM-DD&nbsp;&nbsp;HH:MM:SS")}}</p>
					</div>
					<span class="item-value" :class="{del:item.type=='-'}">{{item.type}}{{item.integral}}</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	
	export default {
		name: "my-integra-detail",
		data() {
			return {
				uid: "",
				integralInfo:"",	//积分信息
				nowPage:1,
			}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			
			this.getIntegralDetail();
			
			
		},
		methods: {
			getIntegralDetail(){
				this.$axios({
					url:"My/UserIntegralDetails",
					method:"post",
					data:{
						uid:this.uid,
						page:this.nowPage
					}
				}).then(res=>{
					console.log(res.data.data);
					if(res.data.code==200){
						this.integralInfo = res.data.data;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			
		}
	}
</script>

<style scoped>
	.integral-detail-wrap {
		padding-top: 2.5rem;
	}
	.detail-list li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.55rem 1rem;
		background: #fff;
		border-bottom: 1px solid #f3f3f3;
	}
	.detail-list li .item-name{
		flex: 1;
	}
	.detail-list li .item-title{
		font-size: 1rem;
		color: #282828;
		line-height: 1.8rem;
		font-weight: bold;
	}
	.detail-list li .item-time{
		font-size: 0.6rem;
		color: #7b7b7b;
	}
	.detail-list li .item-value{
		font-size: 1.1rem;
		color: #5415F9;
		font-weight: bold;
	}
	.detail-list li .item-value.del{
		color: #7b7b7b;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/MyIntegralDetail.vue